module.exports = __webpack_public_path__ + "img/icon-filter.c7919a2f.svg";